// extracted by mini-css-extract-plugin
module.exports = {"desc":"BestA11yExperienceDesc_desc__3gOEh"};